import React from 'react';
import { useApp } from '../context/AppContext';
import MovieCard from '../components/MovieCard';
import { Bookmark } from 'lucide-react';
import { Link } from 'react-router-dom';

const MyList = () => {
  const { myList, profile } = useApp();

  return (
    <div className="min-h-screen pt-16 px-10 pb-20">
      <div className="flex items-end justify-between max-w-6xl">
        <div>
          <div className="text-white/50 text-sm tracking-widest uppercase">{profile?.name}'s Collection</div>
          <h1 className="font-display text-5xl md:text-6xl text-white mt-2">My List</h1>
          <p className="text-white/60 mt-2">{myList.length} title{myList.length === 1 ? '' : 's'} saved to watch later.</p>
        </div>
      </div>

      {myList.length === 0 ? (
        <div className="mt-20 flex flex-col items-center justify-center text-center max-w-md mx-auto">
          <div className="w-20 h-20 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-5">
            <Bookmark className="text-white/50" size={32} />
          </div>
          <h3 className="text-xl font-semibold">Your list is empty</h3>
          <p className="text-white/60 mt-2">Tap the + on any title to save it here for later.</p>
          <Link to="/" className="mt-6 inline-flex px-6 py-3 rounded-lg bg-white text-black font-semibold hover:bg-white/90 tv-focusable">Browse titles</Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-5">
          {myList.map((it) => (
            <MovieCard key={it._key} item={it} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MyList;
